'use strict';

/* globals RELATIVE_PATH, scrollToSmooth, socket */

require([
	RELATIVE_PATH + '/plugins/nodebb-plugin-fill-blanks-game/static/vendor/vue.js',
], function (Vue) {
	var internals = {};

	Vue.component('fill-blanks-game-words', {
		props: ['initData'],
		data: function () {
			return {
				words: [],
				index: -1,
				showNextWordNavigation: false,
				wrongAnswers: 0,
				startTime: null,
			};
		},
		computed: {
			currentWord: function () {
				return this.words[this.index];
			}
		},
		mounted: function () {
			this.words = this.initData.game.words;
			this.words.shuffle();
			this.nextWord();
		},
		methods: {
			onWordSuccess: function (wrongAnswers) {
				internals.logNextWord(this.initData.uuid, this.startTime, Date.now(), this.index, wrongAnswers);
				
				this.showNextWordNavigation = true;
			},
			nextWord: function () {
				this.startTime = Date.now();
				
				this.showNextWordNavigation = false;
				this.index++;
				
				if (this.index === this.words.length) {
					internals.logFinishedGame(this.initData.uuid);
					this.initData.isCompleted = true;
				}
			},
			goNext: function () {
				if (this.showNextWordNavigation) {
					this.nextWord();
				}
			}
		},
		template:
		'<div>' +
			'<fill-blanks-game-word :init-data="initData" :word="currentWord" :on-word-success="onWordSuccess" :go-next="goNext"></fill-blanks-game-word>' +
			'<div class="text-center" v-if="showNextWordNavigation">' +
				'<h2 class="text-success">{{initData.translations.successWord}}</h2>' +
				'<button type="button" class="btn btn-primary" v-on:click="nextWord()">{{initData.translations.nextWord}}</button>' +
			'</div>' +
		'</div>',
	});
	
	internals.logFinishedGame = function (uuid) {
		socket.emit('plugins.fillBlanksGameAnalytics.finishedGame', { uuid: uuid });
	};

	internals.logNextWord = function (uuid, started, finished, index, wrongAnswers) {
		socket.emit('plugins.fillBlanksGameAnalytics.finishedWord', { uuid: uuid, started: started, finished: finished, index: index, wrongAnswers: wrongAnswers });
	};
});
